import { useState } from "react";

const PERSIAN_LETTERS = [
  "الف",
  "ب",
  "پ",
  "ت",
  "ث",
  "ج",
  "چ",
  "ح",
  "خ",
  "د",
  "ذ",
  "ر",
  "ز",
  "ژ",
  "س",
  "ش",
  "ص",
  "ط",
  "ع",
  "ف",
  "ق",
  "ک",
  "گ",
  "ل",
  "م",
  "ن",
  "و",
  "ه",
  "ی",
];

export default function PlateField({ value, onChange }) {
  const [plate, setPlate] = useState({
    first: "",
    letter: "",
    middle: "",
    city: "",
  });

  const formatPlate = (p) =>
    `${p.city} ایران ${p.middle} ${p.letter} ${p.first}`.trim();

  const handleChange = (field, val) => {
    const updated = { ...plate, [field]: val };
    setPlate(updated);
    onChange({
      target: {
        name: "plateNumber",
        value: formatPlate(updated),
      },
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        direction: "ltr",
        gap: "4px",
        alignItems: "center",
      }}
    >
      <input
        maxLength={2}
        value={plate.first}
        onChange={(e) => handleChange("first", e.target.value)}
        className="w-10 h-9 text-center border rounded"
        placeholder="12"
      />
      <select
        value={plate.letter}
        onChange={(e) => handleChange("letter", e.target.value)}
        className="w-16 h-9 border rounded text-center"
      >
        <option value="">-</option>
        {PERSIAN_LETTERS.map((l) => (
          <option key={l} value={l}>
            {l}
          </option>
        ))}
      </select>
      <input
        maxLength={3}
        value={plate.middle}
        onChange={(e) => handleChange("middle", e.target.value)}
        className="w-14 h-9 text-center border rounded"
        placeholder="345"
      />
      <span className="text-xs text-gray-500">ایران</span>
      <input
        maxLength={2}
        value={plate.city}
        onChange={(e) => handleChange("city", e.target.value)}
        className="w-10 h-9 text-center border rounded"
        placeholder="22"
      />
    </div>
  );
}
